// import Banner from './Banner';
import React from "react";
import { connect } from "react-redux";
import {
    Card,
    Table,
    Space,
    Button,
    Popconfirm,
    Drawer,
    Form,
    Input,
    Tooltip,
    Select,
    Menu,
    Dropdown,
} from "antd";
import FormDrawer from "../../components/FormDrawer/FormDrawer";
import agent from "../../agent";
import {
    USERS,
    USER_DELETE,
    USER_CREATE,
    USER_UPDATE,
    LOGOUT,
    CREATE_TWO_FACTOR,
    DOWNLOAD_TWO_FACTOR,
    UPDATE_TWO_FACTOR_STATUS,
} from "../../constants/actionTypes";
import {
    STATUS,
    STATUS_LABEL,
    USER_TYPE,
    PASSWORD_REGEX,
    PASSWORD_ERR_MSG,
} from "../../constants/constants";
import openNotification from "../../components/Notification/Notificaiton";
const { Option } = Select;

const mapStateToProps = (state) => ({
    // ...state.home,
    users: state.users,
    currentUser: state.common.currentUser,
    // token: state.common.token
});

const mapDispatchToProps = (dispatch) => ({
    getUsers: (params) =>
        dispatch({ type: USERS, payload: agent.User.readAll() }),
    getCurrentUsers: (uuid) =>
        dispatch({ type: USERS, payload: agent.User.readOne(uuid) }),
    deleteUser: (username) =>
        dispatch({ type: USER_DELETE, payload: agent.User.delete(username) }),
    createUser: (params) =>
        dispatch({ type: USER_CREATE, payload: agent.User.create(params) }),
    updateUser: (username, data) =>
        dispatch({
            type: USER_UPDATE,
            payload: agent.User.update(username, data),
        }),
    logout: () => dispatch({ type: LOGOUT }),
    createCert: (uuid) =>
        dispatch({
            type: CREATE_TWO_FACTOR,
            payload: agent.TwoFactor.createCert(uuid),
        }),
    downloadCert: (uuid, ref) =>
        dispatch({
            type: DOWNLOAD_TWO_FACTOR,
            payload: agent.TwoFactor.downloadCert(uuid, ref),
        }),
    update2FA: (uuid, payload) =>
        dispatch({
            type: UPDATE_TWO_FACTOR_STATUS,
            payload: agent.TwoFactor.updateCert(uuid, payload),
        }),
});

var downloadRef = React.createRef();

const SideDrawer = ({
    visible,
    setVisible,
    formData,
    handleClickSubmit,
    formRef,
}) => {
    // console.log("formData", formData)
    // console.log("formData.row", formData.row)
    // console.log("formData.row", formData.row && formData.row.username)
    return (
        <Drawer
            title={
                formData.title === "addUser"
                    ? "Add User"
                    : formData.title === "editUser"
                    ? "Edit"
                    : formData.title === "editUserNormal"
                    ? "Edit"
                    : formData.title === "changePassword"
                    ? "Change Password"
                    : "Reset Password"
            }
            width={400}
            onClose={setVisible}
            visible={visible}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
                <div
                    style={{
                        textAlign: "right",
                    }}
                >
                    <Space size={5}>
                        <Tooltip placement="bottom" title="Cancel">
                            <Button onClick={setVisible}> Cancel </Button>
                        </Tooltip>
                        <Tooltip placement="bottom" title="Submit">
                            <Button
                                onClick={handleClickSubmit}
                                type="primary"
                                danger
                            >
                                {" "}
                                Submit{" "}
                            </Button>
                        </Tooltip>
                    </Space>
                </div>
            }
        >
            <Form
                // size="large"
                name="addUserForm"
                layout="vertical"
                ref={formRef}
                initialValues={
                    formData.title === "editUser"
                        ? {
                              username: formData.row && formData.row.username,
                              email: formData.row && formData.row.email,
                              role: formData.row && formData.row.role,
                          }
                        : formData.title === "editUserNormal"
                        ? {
                              username: formData.row && formData.row.username,
                              email: formData.row && formData.row.email,
                          }
                        : {
                              username: "",
                              email: "",
                              password: "",
                              confirmPassword: "",
                              role: "Normal",
                          }
                }
            >
                {formData.title === "changePassword" ? (
                    <React.Fragment>
                        <Form.Item label="Old Password" name="oldPassword">
                            <Input.Password
                                placeholder="Please enter Password"
                                role="old password"
                            />
                        </Form.Item>
                        <Form.Item
                            label="New Password"
                            name="newPassword"
                            hasFeedback
                            rules={[
                                {
                                    required: false,
                                    message: "Please confirm your password!",
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            PASSWORD_REGEX.test(
                                                value.toString()
                                            )
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(PASSWORD_ERR_MSG)
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                placeholder="Please enter Password"
                                role="new password"
                            />
                        </Form.Item>
                        <Form.Item
                            label="Confirm Password"
                            name="confirmPassword"
                            dependencies={["newPassword"]}
                            hasFeedback
                            rules={[
                                {
                                    required: false,
                                    message: "Please confirm your password!",
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            getFieldValue("newPassword") ===
                                                value
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(
                                                "The two passwords that you entered do not match!"
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                placeholder="Please enter Confirm Password"
                                role="confirm password"
                            />
                        </Form.Item>
                    </React.Fragment>
                ) : formData.title === "adminResetPassword" ? (
                    <React.Fragment>
                        <Form.Item
                            label="New Password"
                            name="newPassword"
                            hasFeedback
                            rules={[
                                {
                                    required: false,
                                    message: "Please confirm your password!",
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            PASSWORD_REGEX.test(
                                                value.toString()
                                            )
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(PASSWORD_ERR_MSG)
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                placeholder="Please enter Password"
                                role="new password"
                            />
                        </Form.Item>
                        <Form.Item
                            label="Confirm Password"
                            name="confirmPassword"
                            dependencies={["newPassword"]}
                            hasFeedback
                            rules={[
                                {
                                    required: false,
                                    message: "Please confirm your password!",
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (
                                            !value ||
                                            getFieldValue("newPassword") ===
                                                value
                                        ) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error(
                                                "The two passwords that you entered do not match!"
                                            )
                                        );
                                    },
                                }),
                            ]}
                        >
                            <Input.Password
                                placeholder="Please enter Confirm Password"
                                role="confirm password"
                            />
                        </Form.Item>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <Form.Item label="Username" name="username">
                            <Input
                                type="text"
                                name="username"
                                placeholder="Please enter  user name"
                                autoComplete
                                role="username"
                                disabled={formData.title === "editUserNormal"}
                            />
                        </Form.Item>
                        <Form.Item label="Email Address" name="email">
                            <Input
                                type="email"
                                name="email"
                                placeholder="Please enter email address"
                                autoComplete
                                role="email"
                            />
                        </Form.Item>
                        {formData.title !== "editUser" &&
                        formData.title !== "editUserNormal" ? (
                            <React.Fragment>
                                <Form.Item
                                    label="Password"
                                    name="password"
                                    hasFeedback
                                    rules={[
                                        {
                                            required: false,
                                            message:
                                                "Please confirm your password!",
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (
                                                    !value ||
                                                    PASSWORD_REGEX.test(
                                                        value.toString()
                                                    )
                                                ) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(
                                                    new Error(PASSWORD_ERR_MSG)
                                                );
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Please enter Password"
                                        autoComplete
                                        role="password"
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Confirm Password"
                                    name="confirmPassword"
                                    dependencies={["password"]}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: false,
                                            message:
                                                "Please confirm your password!",
                                            // pattern: /^[0-9]+$/
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (
                                                    !value ||
                                                    getFieldValue(
                                                        "password"
                                                    ) === value
                                                ) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(
                                                    new Error(
                                                        "The two passwords that you entered do not match!"
                                                    )
                                                );
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password
                                        placeholder="Please enter Confirm Password"
                                        autoComplete
                                        role="confirm password"
                                    />
                                </Form.Item>
                            </React.Fragment>
                        ) : (
                            ""
                        )}
                    </React.Fragment>
                )}
            </Form>
        </Drawer>
    );
};
class Users extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            btnSize: "small",
            visible: false,
            formData: {},
            data: [],
        };
        this.formRef = React.createRef();
    }

    showDrawer = (e, record) => {
        this.setState({
            visible: true,
            formData: { title: e, row: record },
        });
    };

    handleClickSubmit = (e) => {
        console.log("ktk", this.formRef.current.getFieldValue());
        console.log("kt", this.state.formData.title);
        if (this.state.formData.title === "editUser") {
            let { username, email, role } =
                this.formRef.current.getFieldValue();
            let payload = {
                username: username,
                email: email,
                type: this.state.formData.title,
                role: role,
            };
            this.props.updateUser(this.state.formData.row.uuid, payload);
        }

        if (this.state.formData.title === "editUserNormal") {
            let { email } = this.formRef.current.getFieldValue();
            let payload = {
                email: email,
                type: this.state.formData.title,
            };
            this.props.updateUser(this.state.formData.row.uuid, payload);
        }

        if (
            this.state.formData.title === "adminResetPassword" ||
            this.state.formData.title === "changePassword"
        ) {
            let { oldPassword, newPassword, confirmPassword } =
                this.formRef.current.getFieldValue();
            if (
                oldPassword === "" ||
                newPassword === "" ||
                confirmPassword === ""
            ) {
                openNotification({
                    type: "error",
                    message: "Error",
                    description: "Please input all the required fields",
                });
                return;
            }
            if (newPassword !== confirmPassword) {
                openNotification({
                    type: "error",
                    message: "Error",
                    description: "The two passwords must match!",
                });
                return;
            }
            let payload = {
                oldPassword,
                oldPassword,
                newPassword: newPassword,
                type: this.state.formData.title,
            };
            this.props.updateUser(this.state.formData.row.uuid, payload);
        }

        if (this.state.formData.title === "addUser") {
            let { username, email, password, role, confirmPassword } =
                this.formRef.current.getFieldValue();
            if (
                username === "" ||
                email === "" ||
                password === "" ||
                confirmPassword === ""
            ) {
                openNotification({
                    type: "error",
                    message: "Error",
                    description: "Please input all the required fields",
                });
                return;
            }
            if (password !== confirmPassword) {
                openNotification({
                    type: "error",
                    message: "Error",
                    description: "The two passwords must match!",
                });
                return;
            }
            let payload = {
                username: username,
                email: email,
                password: password,
                current_user: "System",
                role: role,
            };
            this.props.createUser(payload);
        }

        this.setState({
            visible: false,
            // formData:null
        });
    };

    handleClickDropdown = async (key, record) => {

        if (key === "create") {
            await this.props.createCert(record.uuid);
            window.location.reload();
        }
        if (key === "download") {
            await this.props.downloadCert(record.uuid, downloadRef);
        }
        if (key === "disableStatus" || key === "enableStatus") {
            var payload = {
                status: key === "enableStatus" ? "enable" : "disable",
            };
            await this.props.update2FA(record.uuid, payload);
            window.location.reload();
        }
    };

    onClose = () => {
        this.setState({
            visible: false,
            // formData:null
        });
    };

    handleDelete = async (key) => {
        this.props.deleteUser(key);
    };

    componentWillMount() {}
    componentWillUnmount() {}
    componentDidMount() {
        if (this.props.currentUser && this.props.currentUser.user_role) {
            if (this.props.currentUser.user_role === "Admin") {
                this.props.getUsers();
            } else {
                this.props.getCurrentUsers(this.props.currentUser.uuid);
            }
        }
    }

    componentWillReceiveProps(nextProps) {}

    componentDidUpdate(prevProps, prevState) {
        var { isLoadData, message, statusCode } = this.props.users;
        if (
            (this.props.currentUser &&
                prevProps.currentUser !== this.props.currentUser) ||
            isLoadData
        ) {
            if (this.props.currentUser.user_role === "Admin") {
                this.props.getUsers();
            } else {
                this.props.getCurrentUsers(this.props.currentUser.uuid);
            }
        }

        if (message) {
            var isSuccess = statusCode && statusCode === 200;
            openNotification({
                type: isSuccess ? "success" : "error",
                message: isSuccess ? "Success" : "Error",
                description: message,
            });
        }
    }

    render() {
        const { size, settingPaginationTotal } = this.props;
        const cert_menu = (props) => (
            <Menu onClick={({ key }) => this.handleClickDropdown(key, props)}>
                <Popconfirm
                    title="Generate new Certificate will remove old Certificate."
                    key="downloadConfirm"
                    onConfirm={() => this.handleClickDropdown("create", props)}
                >
                    <Menu.Item key="click_create">Generate Certificate</Menu.Item>
                </Popconfirm>
                <Menu.Item
                    key="download"
                    // onClick={this.handleClickDownloadKey(props)}
                >
                    Download Certificate
                </Menu.Item>
                <Menu.Item
                    key={
                        props.twoFactor === "enable"
                            ? "disableStatus"
                            : "enableStatus"
                    }
                    // onClick={this.handleEnableKey(props)}
                >
                    {props.twoFactor === "enable" ? "Disable" : "Enable"} 2FA
                </Menu.Item>
            </Menu>
        );

        const columns = [
            {
                title: "",
                dataIndex: "hash",
                key: "hash",
                width: "50px",
            },
            {
                title: "User Name",
                dataIndex: "username",
                key: "username",
                width: "200px",
            },
            {
                title: "Email Address",
                dataIndex: "email",
                key: "email",
                width: "200px",
                // align:"right"
            },
            {
                title: "Actions",
                dataIndex: "actions",
                key: "actions",
                // width: "550px",
                width: "400px",
                align: "right",
                render: (_, record) =>
                    this.props.users.users.length >= 1 &&
                    this.props.currentUser &&
                    this.props.currentUser.user_role === "Admin" ? (
                        <Space size={2}>
                            {/* <Button
                                type="link"
                                size="small"
                                onClick={(e) =>
                                    this.showDrawer("editUser", record)
                                }
                            >
                                Edit
                            </Button> */}
                            <Button
                                type="link"
                                size="small"
                                onClick={(e) =>
                                    this.showDrawer(
                                        "adminResetPassword",
                                        record
                                    )
                                }
                            >
                                Reset Password
                            </Button>
                            <Popconfirm
                                title="Sure to delete?"
                                onConfirm={() => this.handleDelete(record.key)}
                                placement="leftTop"
                            >
                                <Button type="text" danger size="small">
                                    Delete
                                </Button>
                            </Popconfirm>
                            <Dropdown.Button overlay={cert_menu(record)} />
                        </Space>
                    ) : this.props.users.users.length >= 1 &&
                      this.props.currentUser &&
                      this.props.currentUser.user_role !== "Admin" ? (
                        <Space size={2}>
                            <Button
                                type="link"
                                size="small"
                                onClick={(e) =>
                                    this.showDrawer("editUserNormal", record)
                                }
                            >
                                Edit
                            </Button>
                            <Button
                                type="link"
                                size="small"
                                onClick={(e) =>
                                    this.showDrawer("changePassword", record)
                                }
                            >
                                Change Password{" "}
                            </Button>
                        </Space>
                    ) : null,
            },
        ];

        return (
            <React.Fragment>
                <div className="grid height_100">
                    <Card
                        size={this.state.btnSize}
                        className="height_100"
                        title={<h1>User account management</h1>}
                        extra={
                            this.props.currentUser &&
                            this.props.currentUser.user_role === "Admin" && (
                                <Space size={4}>
                                    <Tooltip placement="bottom" title="Add">
                                        <Button
                                            type="primary"
                                            className="btn-green"
                                            onClick={(e) =>
                                                this.showDrawer("addUser", null)
                                            }
                                        >
                                            Add
                                        </Button>
                                    </Tooltip>
                                </Space>
                            )
                        }
                    >
                        <Table
                            // className="largeFont"
                            // style={{ marginTop: '15px' }}
                            size={size}
                            dataSource={this.props.users.users}
                            // dataSource={this.state.data}
                            columns={columns}
                            bordered={true}
                            pagination={{
                                simple: false,
                                showTotal: (total, range) =>
                                    `${range[0]}-${range[1]} of ${total} items`,
                                showSizeChanger: true,
                                // size:"default",
                                // total: 20,
                                // pageSize: 17,
                            }}
                            scroll={{ y: "calc(100vh - 220px)" }}
                        />
                    </Card>
                    <a ref={downloadRef}> </a>
                </div>
                {this.state.visible && (
                    <SideDrawer
                        visible={this.state.visible}
                        setVisible={this.onClose}
                        formData={this.state.formData}
                        handleClickSubmit={this.handleClickSubmit}
                        formRef={this.formRef}
                    />
                )}
            </React.Fragment>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);



// WEBPACK FOOTER //
// src/layouts/views/users.js